var axios = require('axios');
import { friendList } from "../engine/data/mockdata";

//generators
const generateRequestOpts = (url, method = 'get', params) => {
  return {
    method: method,
    url: url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    params
  }
}


const getWorldData = (url, successCallback, errorCallback) => {
  let config = generateRequestOpts(url)
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error)
      errorCallback && errorCallback(error)
    });
}
const getProfileInfo = (id, successCallback, errorCallback) => {
  const url = "/profile/info/" + id;
  let config = generateRequestOpts(url)
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error)
      errorCallback && errorCallback(error)
    });
}


const saveWorldData = (url, data, initSave, successCallback, errorCallback) => {
  var config = {
    method: 'post',
    url: url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data
  };

  axios(config)
    .then(function (response) {
      console.log(response);
      console.log('%c saved worldData! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response)
      const temp = new URLSearchParams(window.location.search);
      const worldID = temp.get('id');
      !initSave && localStorage.setItem(`dispatch_change_${worldID}`, 'true'); // inform active users about the change
      localStorage.getItem(`publish_${worldID}`) && localStorage.removeItem(`publish_${worldID}`);
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });

}

const updateSpaceType = (url, data, successCallback, errorCallback) => {
  var config = {
    method: 'post',
    url: url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data
  };

  axios(config)
    .then(function (response) {
      console.log(response);
      console.log('%c saved space type! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}


const saveProfileData = (url, data, successCallback, errorCallback) => {
  var config = {
    method: 'post',
    url: url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data
  };

  axios(config)
    .then(function (response) {
      console.log(response);
      console.log('%c saved profile! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });

}


const saveSpaceConsentData = (url, data, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    data,
  };
  return axios(config)
    .then(function (response) {
      successCallback && successCallback(response);
      return response;
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error);
      throw error;
    });
};

const saveWorldTrackingData = (url, data, successCallback, errorCallback) => {
  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data
  };

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const getGlobalHistory = (worldId, successCallback, errorCallback) => {
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    return;
  }
  const url = "/rest/get-world-chats?worldId=" + worldId;
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  };

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const getLocalRoomHistory = (roomId, successCallback, errorCallback) => {
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    return;
  }
  const url = "/rest/get-room-chats?roomId=" + roomId;
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  };

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const getWorldVersions = (worldId, successCallback, errorCallback) => {
  const url = "/world-versions/list?id=" + worldId;
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  };

  axios(config)
    .then(function (response) {
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const getUsers = (successCallback, errorCallback) => {
  const url = "/rest/get-users";
  // const url = "https://apprc.bagless.io/rest/get-users";
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  };

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const findUserByEmail = (email, worldId, successCallback, errorCallback) => {
  const url = `/rest/find-by-email?email=${encodeURIComponent(email)}&worldId=${worldId}`;
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  };

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const findOneUserByEmail = (email, successCallback, errorCallback) => {
  const url = `/rest/find-one-user-by-email?email=${encodeURIComponent(email)}`;
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  };

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}
const addContributore = (userid, worldId, successCallback, errorCallback) => {
  const url = `/rest/set-world-contributore`;
  // const url = `https://apprc.bagless.io/rest/set-world-contributore`
  const data = {
    worldId: worldId, user_id: userid
  };
  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data,

  }

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const removeContributore = (userid, worldId, successCallback, errorCallback) => {
  const url = `/rest/remove-world-contributore`;
  // const url = `https://apprc.bagless.io/rest/remove-world-contributore`;
  const data = {
    worldId: worldId, user_id: userid
  };
  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data,
  }

  axios(config)
    .then(function (response) {
      //console.log(response);
      if (response.data.redirect) {
        window.location.href = 'https://bagless.io/';
      }
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}
const getContributores = (worldId, successCallback, errorCallback) => {
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    return;
  }
  const url = `/rest/get-world-contributore?worldId=${Number(worldId)}`;
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  }

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}
const getGuestVisitors = (worldId, successCallback, errorCallback) => {
  const url = `/rest/get-world-guest-visitors?worldId=${Number(worldId)}`;
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  }

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}
const removeGuestVisitors = (userid, worldId, successCallback, errorCallback) => {
  const url = `/rest/remove-guest-visitor`;
  // const url = `https://apprc.bagless.io/rest/remove-world-contributore`;
  const data = {
    worldId: worldId, user_id: userid
  };
  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data,
  }

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}
const addOwner = (email, worldId, successCallback, errorCallback) => {
  const url = `/worlds/set-owner?id=${Number(worldId)}&email=${encodeURIComponent(email)}`;
  const data = {
    worldId: Number(worldId)
  };
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  }

  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const getWorldDataFromId = (worldId, successCallback, errorCallback) => {
  const url = `/worlds/get-world-data?id=${Number(worldId)}`;
  console.log('worldId', worldId, url);
  const config = generateRequestOpts(url, "get")
  axios(config)
    .then(function (response) {
      //console.log(response);
      //console.log('%c saved tracking data! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const saveWorldCoordinates = (props, successCallback, errorCallback) => {
  const { url, latlng, worldID } = props;

  const config = {
    method: 'post',
    url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data: {
      latlng,
      worldID,
    }
  };

  axios(config)
    .then(function (response) {
      console.log('%c saved room coordinates! ', 'color:black; background: #bada55; font-weight:bold');
      successCallback && successCallback(response);
    })
    .catch(function (error) {
      errorCallback && errorCallback(error);
    });
}

const saveLanguage = (lang, successCallback, errorCallback) => {
  // Create form data to send as application/x-www-form-urlencoded
  const formData = new URLSearchParams();
  formData.append('language', lang);

  const config = {
    method: 'post',
    url: '/language/update',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data: formData
  };

  return axios(config)
    .then(function (response) {
      successCallback && successCallback(response);
      return response;
    })
    .catch(function (error) {
      console.error('Error synchronizing language with backend:', error);
      errorCallback && errorCallback(error);
      return Promise.reject(error);
    });
}

const getLanguage = (successCallback, errorCallback) => {
  const config = {
    method: 'get',
    url: '/language',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    }
  };

  axios(config)
    .then(function (response) {
      successCallback && successCallback(response);
    })
    .catch(function (error) {
      console.error('Error getting language from backend:', error);
      errorCallback && errorCallback(error);
    });
}


const getFriendsList = (successCallback, errorCallback) => {
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    return;
  }
  const url = `/rest/get-friends`;
  const config = generateRequestOpts(url, "get");

  axios(config)
    .then(function (response) {
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const getOnlineUsers = (worldId, successCallback, errorCallback) => {
  const url = `/spaces/online-users?worldId=${worldId}`;
  const config = generateRequestOpts(url, "get");

  axios(config)
    .then(function (response) {
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const getOnlineUserCounts = (worldIds, successCallback, errorCallback) => {
  const ids = (worldIds || []).map((id) => Number(id)).filter((id) => id > 0);
  if (!ids.length) {
    successCallback && successCallback({ counts: {} });
    return;
  }
  const url = `/spaces/online-counts?worldIds=${ids.join(',')}`;
  const config = generateRequestOpts(url, "get");

  axios(config)
    .then(function (response) {
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const addAsFriend = (userId, successCallback, errorCallback) => {
  const url = `/rest/add-friend`;
  const data = { "user_id": userId };

  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data,
  }
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const addAsGuest = (userId, worldId, successCallback, errorCallback) => {
  const url = `/rest/add-guest-visitor`;
  const data = { "userId": userId, "worldId": worldId };

  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data,
  }
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const removeFriend = (userId, successCallback, errorCallback) => {
  const url = `/rest/remove-friend`;
  const data = { "user_id": userId };

  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data,
  }
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const buyLocationTicket = (url, data) => {

  const config = {
    method: 'post',
    url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    data
  };

  $(".loading-spinner").addClass('visible');

  axios(config)
    .then(function (response) {
      $(".loading-spinner").removeClass('visible');
      window.location.href = response.data;
    })
    .catch(function (error) {
      $(".loading-spinner").removeClass('visible');
      console.error(error)
    });
}

const getUserById = (id, successCallback, errorCallback) => {
  const url = `/rest/get-user-by-id`;
  const data = { "userId": id };
  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data
  }
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response.data.remote_id)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const addAvatar = (name, url, onSuccess, onError) => {
  const data = {
    'name': name,
    'url': url
  };
  const config = {
    method: 'post',
    url: "/avatar/add",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    data
  };

  axios(config)
    .then(function (response) {
      $(".loading-spinner").removeClass('visible');
      onSuccess && onSuccess(response)
    })
    .catch(function (error) {
      $(".loading-spinner").removeClass('visible');
      onError && onError(response);
      console.error(error)
    });

}

const getAvatars = (successCallback, errorCallback) => {
  const url = `/avatars`;
  let config = {
    method: 'get',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
  }
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const addImage = (formData, onSuccess, onError) => {
  const config = {
    method: 'post',
    url: "/media/add-image",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      // Don't manually set 'Content-Type' as it should be multipart/form-data with boundary
    },
    data: formData
  };

  axios(config)
    .then(function (response) {
      $(".loading-spinner").removeClass('visible');
      onSuccess && onSuccess(response);
    })
    .catch(function (error) {
      $(".loading-spinner").removeClass('visible');
      onError && onError(error);
      console.error(error);
    });
}
const sendSupportData = (data, email, onSuccess) => {
  const config = {
    method: 'post',
    url: "/self-check/create",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      // Don't manually set 'Content-Type' as it should be multipart/form-data with boundary
    },
    data: { data, email }
  };

  axios(config)
    .then(function (response) {
      $(".loading-spinner").removeClass('visible');
      onSuccess && onSuccess(response);
    })
    .catch(function (error) {
      $(".loading-spinner").removeClass('visible');
      onError && onError(error);
      console.error(error);
    });
}
const getWorldIdSec = (worldId, successCallback, errorCallback) => {
  const url = `/rest/get-world-id-sec?worldId=${worldId}`;
  let config = {
    method: 'get',
    url: url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    }
  }
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}
const sendTrack = (data, successCallback, errorCallback) => {
  return;
  const url = `/some-post-track-url`;
  let config = {
    method: 'post',
    url: url,
    //json
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      //'X-CSRF-Token': window.yii.getCsrfToken()
    },
    data: { data }
  }
  axios(config)
    .then(function (response) {
      successCallback && successCallback(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorCallback && errorCallback(error)
    });
}

const saveVapiAgentConfig = (worldId, agentId, assistantId, privateKey, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-agent/save-config',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, agentId, assistantId, privateKey: privateKey || '' }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const deleteVapiAgentConfig = (worldId, agentId, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-agent/delete-config',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, agentId }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const saveInputFieldGuessAnswer = (worldId, objectId, correctAnswer, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/input-field-guess/save-answer',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, objectId, correctAnswer }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const checkInputFieldGuessAnswer = (worldId, objectId, answer, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/input-field-guess/check-answer',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, objectId, answer }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const deleteInputFieldGuessAnswer = (worldId, objectId, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/input-field-guess/delete-answer',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, objectId }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const saveInputFieldSessionData = (payload, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/input-field/save',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: payload
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const listVapiAgents = (worldId, successCallback, errorCallback) => {
  const config = {
    method: 'get',
    url: '/vapi-agent/list-agents',
    params: { worldId },
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const createVapiLibraryAgent = (worldId, name, chairScenario, assistantId, privateKey, agentImage, successCallback, errorCallback, agentConfig = null) => {
  const data = { worldId, name, chairScenario: chairScenario || '', assistantId, privateKey: privateKey || '', agentImage: agentImage || '' };
  if (agentConfig != null) {
    data.agentConfig = typeof agentConfig === 'string' ? agentConfig : JSON.stringify(agentConfig);
  }
  const config = {
    method: 'post',
    url: '/vapi-agent/create-library-agent',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data,
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const placeVapiAgentFromLibrary = (worldId, libraryId, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-agent/place-from-library',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, libraryId }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const updateVapiLibraryAgent = (worldId, libraryId, name, chairScenario, agentImage, assistantId, successCallback, errorCallback, privateKey = '') => {
  const config = {
    method: 'post',
    url: '/vapi-agent/update-library-agent',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: {
      worldId,
      libraryId,
      name,
      chairScenario: chairScenario || '',
      agentImage: agentImage || '',
      assistantId: assistantId || '',
      privateKey: privateKey || ''
    }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const switchAgentConfig = (worldId, agentId, libraryId, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-agent/switch-agent-config',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, agentId, libraryId }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const deleteVapiLibraryAgent = (worldId, libraryId, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-agent/delete-library-agent',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, libraryId }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const listVapiAiTokens = (worldId, successCallback, errorCallback) => {
  const config = {
    method: 'get',
    url: '/vapi-ai-token/list',
    params: { worldId },
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const createVapiAiToken = (worldId, data, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-ai-token/create',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, ...data }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const updateVapiAiToken = (worldId, data, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-ai-token/update',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, ...data }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const deleteVapiAiToken = (worldId, id, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-ai-token/delete',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, id }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const resolveVapiAiToken = (worldId, token, successCallback, errorCallback) => {
  const config = {
    method: 'get',
    url: '/vapi-ai-token/resolve',
    params: { worldId, token },
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const recordVapiAiTokenCall = (worldId, token, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/vapi-ai-token/record-call',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, token }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const reportVapiAiToken = (worldId, token, successCallback, errorCallback) => {
  const config = {
    method: 'get',
    url: '/vapi-ai-token/report',
    params: { worldId, token },
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const listWorldEvents = (worldId, successCallback, errorCallback) => {
  const config = {
    method: 'get',
    url: '/world-event/list',
    params: { worldId },
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const createWorldEvent = (data, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/world-event/create',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const deleteWorldEvent = (worldId, id, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/world-event/delete',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, id }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

const deleteEventsByObjectId = (worldId, objectId, successCallback, errorCallback) => {
  const config = {
    method: 'post',
    url: '/world-event/delete-by-object-id',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: { worldId, objectId }
  };
  axios(config)
    .then((r) => successCallback && successCallback(r.data))
    .catch((e) => errorCallback && errorCallback(e));
};

export const fetcher = {
  addImage,
  getWorldData,
  saveWorldData,
  updateSpaceType,
  saveProfileData,
  getGlobalHistory,
  getLocalRoomHistory,
  getWorldVersions,
  saveWorldTrackingData,
  saveSpaceConsentData,
  getUsers,
  findUserByEmail,
  addContributore,
  removeContributore,
  getContributores,
  addOwner,
  getWorldDataFromId,
  saveWorldCoordinates,
  getFriendsList,
  getOnlineUsers,
  getOnlineUserCounts,
  addAsFriend,
  removeFriend,
  saveLanguage,
  getLanguage,
  buyLocationTicket,
  getUserById,
  findOneUserByEmail,
  getGuestVisitors,
  addAsGuest,
  removeGuestVisitors,
  addAvatar,
  getAvatars,
  getProfileInfo,
  sendSupportData,
  sendTrack,
  getWorldIdSec,
  saveVapiAgentConfig,
  deleteVapiAgentConfig,
  saveInputFieldGuessAnswer,
  checkInputFieldGuessAnswer,
  deleteInputFieldGuessAnswer,
  saveInputFieldSessionData,
  listVapiAgents,
  createVapiLibraryAgent,
  placeVapiAgentFromLibrary,
  updateVapiLibraryAgent,
  deleteVapiLibraryAgent,
  listVapiAiTokens,
  createVapiAiToken,
  updateVapiAiToken,
  deleteVapiAiToken,
  resolveVapiAiToken,
  recordVapiAiTokenCall,
  reportVapiAiToken,
  switchAgentConfig,
  listWorldEvents,
  createWorldEvent,
  deleteWorldEvent,
  deleteEventsByObjectId,
}
